// Catálogo curado dos temas PrimeReact oferecidos em Configuracao.temacaptive (não o catálogo
// completo do PrimeReact instalado — só as famílias mais atuais/leves). Cores hex copiadas de
// AppThemeConfigurator.js (THEME_FAMILIES/SOLO_DARK) — mantenha os dois em sincronia manualmente
// se os valores de referência mudarem lá; não são importadas de lá porque são conceitos
// diferentes (preferência pessoal do usuário logado vs. tema do portal cativo por publicação).
const CATALOGO_TEMAS_CAPTIVE = [
    { id: 'lara-light-amber', familia: 'lara-light', cor: '#f59e0b' },
    { id: 'lara-light-blue', familia: 'lara-light', cor: '#3b82f6' },
    { id: 'lara-light-cyan', familia: 'lara-light', cor: '#06b6d4' },
    { id: 'lara-light-green', familia: 'lara-light', cor: '#22c55e' },
    { id: 'lara-light-indigo', familia: 'lara-light', cor: '#6366f1' },
    { id: 'lara-light-pink', familia: 'lara-light', cor: '#ec4899' },
    { id: 'lara-light-purple', familia: 'lara-light', cor: '#a855f7' },
    { id: 'lara-light-teal', familia: 'lara-light', cor: '#14b8a6' },
    { id: 'lara-dark-amber', familia: 'lara-dark', cor: '#f59e0b' },
    { id: 'lara-dark-blue', familia: 'lara-dark', cor: '#3b82f6' },
    { id: 'lara-dark-cyan', familia: 'lara-dark', cor: '#06b6d4' },
    { id: 'lara-dark-green', familia: 'lara-dark', cor: '#22c55e' },
    { id: 'lara-dark-indigo', familia: 'lara-dark', cor: '#6366f1' },
    { id: 'lara-dark-pink', familia: 'lara-dark', cor: '#ec4899' },
    { id: 'lara-dark-purple', familia: 'lara-dark', cor: '#a855f7' },
    { id: 'lara-dark-teal', familia: 'lara-dark', cor: '#14b8a6' },
    { id: 'vela-blue', familia: 'vela', cor: '#3b82f6' },
    { id: 'vela-green', familia: 'vela', cor: '#22c55e' },
    { id: 'vela-orange', familia: 'vela', cor: '#f97316' },
    { id: 'vela-purple', familia: 'vela', cor: '#a855f7' },
    { id: 'arya-blue', familia: 'arya', cor: '#4fc3f7' },
    { id: 'arya-green', familia: 'arya', cor: '#66bb6a' },
    { id: 'arya-orange', familia: 'arya', cor: '#ffa726' },
    { id: 'arya-purple', familia: 'arya', cor: '#ce93d8' },
    { id: 'saga-blue', familia: 'saga', cor: '#007bff' },
    { id: 'saga-green', familia: 'saga', cor: '#22c55e' },
    { id: 'saga-orange', familia: 'saga', cor: '#f97316' },
    { id: 'saga-purple', familia: 'saga', cor: '#a855f7' },
    { id: 'viva-light', familia: 'viva', cor: '#3d67e0' },
    { id: 'viva-dark', familia: 'viva', cor: '#3d67e0' },
];

const PREFIXO_CHAVE = 'main.configuracao.temacaptive.';

// Monta a chave i18n (main.configuracao.temacaptive.<familia>.<sufixo>) a partir do id da pasta do
// tema (ex. "vela-blue" -> "main.configuracao.temacaptive.vela.blue").
export function chaveDoTema(pasta) {
    const item = CATALOGO_TEMAS_CAPTIVE.find((t) => t.id === pasta);
    const sufixo = pasta.slice(item.familia.length + 1);
    return `${PREFIXO_CHAVE}${item.familia}.${sufixo}`;
}

// Inverso de chaveDoTema — extrai o id da pasta a partir da chave i18n armazenada.
export function pastaDaChave(chave) {
    return chave.replace(PREFIXO_CHAVE, '').split('.').join('-');
}

export function corDoTema(pasta) {
    return CATALOGO_TEMAS_CAPTIVE.find((t) => t.id === pasta)?.cor || '#94a3b8';
}

export default CATALOGO_TEMAS_CAPTIVE;
